import { Navigate, useLocation } from 'react-router-dom'
import type { ReactNode } from 'react'
import { routePaths } from '@config/routes'
import { isPathAllowedWithoutCompany } from '@shared/navigation/menuAccess'
import { useSelectedCompany } from '@shared/session/companySelection'

export interface CompanyRequiredRouteProps {
  children: ReactNode
}

export function CompanyRequiredRoute({ children }: CompanyRequiredRouteProps) {
  const location = useLocation()
  const { companyId } = useSelectedCompany()

  if (!companyId && !isPathAllowedWithoutCompany(location.pathname)) {
    return <Navigate to={routePaths.welcome} replace />
  }

  return children
}
